import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'CONTRACTOR_WO_PRIORITIES'
);
export const CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CONSTANTS
);
